module.exports = __webpack_public_path__ + "img/ios1icon9.eb70b381.png";